import { render, staticRenderFns } from "./TournamentPostStartRegistration.vue?vue&type=template&id=75036470"
import script from "./TournamentPostStartRegistration.vue?vue&type=script&lang=js"
export * from "./TournamentPostStartRegistration.vue?vue&type=script&lang=js"
import style0 from "./TournamentPostStartRegistration.vue?vue&type=style&index=0&id=75036470&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports